import type { Step } from "react-joyride";

export const formPreviewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຕົວຢ່າງຟອມ! ທ່ານສາມາດເບິ່ງຕົວຢ່າງຂອງຟອມ, ພິມ, ຫຼື ສົ່ງອອກເປັນ PDF. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="preview-back-button"]',
    content:
      "ປຸ່ມນີ້ຈະນຳທ່ານກັບໄປຫນ້າລາຍລະອຽດຟອມ. ທ່ານສາມາດກົດປຸ່ມນີ້ເພື່ອອອກຈາກຫນ້າຕົວຢ່າງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="preview-actions"]',
    content:
      "ນີ້ແມ່ນປຸ່ມການກະທຳ. ທ່ານສາມາດພິມຟອມ ຫຼື ສົ່ງອອກເປັນ PDF. ປຸ່ມເຫຼົ່ານີ້ຈະຖືກຊ້ອນເມື່ອພິມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="preview-content"]',
    content:
      "ນີ້ແມ່ນຕົວຢ່າງຂອງຟອມທີ່ຈະຖືກພິມ ຫຼື ສົ່ງອອກ. ທ່ານສາມາດເບິ່ງຊື່ຟອມ, ຄຳອະທິບາຍ, ແລະຊ່ອງຂໍ້ມູນທັງໝົດ. ຮູບແບບນີ້ຈະຖືກສະແດງໃນ PDF.",
    placement: "top",
  },
  {
    target: '[data-tourid="preview-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນຫົວຂໍ້ຂອງຟອມ. ມັນຈະສະແດງຊື່ບໍລິສັດ, ໝວດໝູ່, ພະແນກ, ແລະວັນທີພິມ. ສ່ວນນີ້ຈະປາກົດໃນ PDF ທຸກຄັ້ງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="preview-form-title"]',
    content:
      "ນີ້ແມ່ນຊື່ຟອມ. ມັນຈະຖືກສະແດງໃນສ່ວນຫົວຂໍ້ຂອງ PDF ແລະຈະຖືກໃຊ້ເປັນຊື່ໄຟລ໌ເມື່ອສົ່ງອອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="preview-fields"]',
    content:
      "ນີ້ແມ່ນພາກສະແດງຊ່ອງຂໍ້ມູນຂອງຟອມ. ທ່ານສາມາດເບິ່ງຊ່ອງຂໍ້ມູນທັງໝົດທີ່ຖືກກຳນົດໃນຟອມ. ຊ່ອງທີ່ຕ້ອງການຈະມີເຄື່ອງໝາຍ * ຢູ່ຂ້າງຊື່.",
    placement: "top",
  },
];
